// extracted by mini-css-extract-plugin
module.exports = {"container":"ValidationErrorMessage_container__2DU5j","sending":"ValidationErrorMessage_sending__3vn12"};